(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ticker"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector('.ticker-container');
  const wrapper = document.querySelector('.ticker-wrapper');
  if (!container || !wrapper) return;

  // Read speed from data attribute (set by section settings)
  const speed = parseFloat(container.dataset.speed) || 50;

  // Duplicate original items to create a seamless loop
  const originalItems = Array.from(wrapper.children);
  originalItems.forEach(item => {
    wrapper.appendChild(item.cloneNode(true));
  });

  // Measure the exact width of one complete set (original items)
  function getSetWidth() {
    return originalItems.reduce((total, item) => {
      // Use getBoundingClientRect for sub-pixel precision
      return total + item.getBoundingClientRect().width;
    }, 0);
  }

  let setWidth = getSetWidth();

  let currentPosition = 0;
  let lastTimestamp = null;
  let animationId = null;
  let isPaused = false;

  function scrollMarquee(timestamp) {
    if (isPaused) {
      lastTimestamp = null;
      animationId = requestAnimationFrame(scrollMarquee);
      return;
    }

    if (lastTimestamp === null) {
      lastTimestamp = timestamp;
      animationId = requestAnimationFrame(scrollMarquee);
      return;
    }

    const delta = timestamp - lastTimestamp; // milliseconds
    const deltaSeconds = delta / 1000;
    const move = speed * deltaSeconds; // pixels to move this frame

    currentPosition -= move;

    // When we've scrolled past one full set, wrap around seamlessly
    if (currentPosition <= -setWidth) {
      currentPosition += setWidth;
    }

    wrapper.style.transform = `translateX(${currentPosition}px)`;

    lastTimestamp = timestamp;
    animationId = requestAnimationFrame(scrollMarquee);
  }

  animationId = requestAnimationFrame(scrollMarquee);

  // Pause on hover
  container.addEventListener('mouseenter', () => {
    isPaused = true;
  });
  container.addEventListener('mouseleave', () => {
    isPaused = false;
  });

  // Recalculate on window resize
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      setWidth = getSetWidth();
      // Keep currentPosition within valid range
      if (currentPosition < -setWidth) {
        currentPosition += setWidth;
      } else if (currentPosition > 0) {
        currentPosition -= setWidth;
      }
    }, 200);
  });
});

  } catch(e) { console.error(e); }
})();
})();
